import { useAuthorization } from 'framework/authorization';
import { useAsyncValue } from 'framework/utils';
import { POSITION_SLOT_EMPLOYEE_VALIDATION } from './constants';
import usePositionSlotValidationService from './usePositionSlotValidationService';

const useEmployeePositionSlotValidationErrors = (
  employeeAlias: Nullable<string>,
  positionSlotId: Nullable<string>,
  enabled = true,
) => {
  const { isGranted } = useAuthorization();
  const { validateEmployeePositionSlots } = usePositionSlotValidationService();
  const canValidatePositionSlot = isGranted(POSITION_SLOT_EMPLOYEE_VALIDATION);

  const validationErrors = useAsyncValue<string[]>(async () => {
    if (!enabled || !canValidatePositionSlot || !employeeAlias || !positionSlotId) return [];

    try {
      const validationResponse = await validateEmployeePositionSlots({ [employeeAlias]: positionSlotId });

      return validationResponse[employeeAlias]?.errors ?? [];
    } catch {
      return [];
    }
  }, [enabled, canValidatePositionSlot, employeeAlias, positionSlotId]);

  return validationErrors;
};

export default useEmployeePositionSlotValidationErrors;
